var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraspSvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.0076 5.85058L2.00767 5.85065L2.01405 5.84292C2.67951 5.03705 3.20503 4.78215 4.0878 4.44062C4.18761 4.402 4.29149 4.36249 4.39995 4.32124C5.29036 3.98258 6.48955 3.52647 8.28157 2.48349C8.88573 2.13244 9.37209 1.82254 9.78063 1.55878C9.83798 1.52175 9.8935 1.48583 9.94737 1.45098C10.2819 1.23455 10.5525 1.05946 10.8013 0.916869C11.3476 0.603796 11.7388 0.47569 12.3222 0.503713C12.9721 0.563676 13.6012 0.76091 14.1668 1.08182C14.7352 1.40434 15.2258 1.84405 15.6055 2.37053L15.6055 2.37056L15.6096 2.37612C17.0295 4.28864 16.407 6.7117 16.0706 7.96716C14.5069 13.2539 9.15779 15.8141 4.36481 13.8284L4.36308 13.8277C2.37884 13.0144 1.12132 11.7986 0.680546 10.4495C0.24719 9.12308 0.560676 7.53294 2.0076 5.85058Z",
    stroke: "#313131"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraspSvgIcon);
export default __webpack_public_path__ + "static/media/grasp_svg_icon.7750fdc8f9b3ac251e90abf3cdd85789.svg";
export { ForwardRef as ReactComponent };